/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_CompareInputs */

const en_btn_compare = /** @type {(inputs: Btn_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare`)
};

const ko_btn_compare = /** @type {(inputs: Btn_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비교`)
};

const ja_btn_compare = /** @type {(inputs: Btn_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較`)
};

/**
* | output |
* | --- |
* | "Compare" |
*
* @param {Btn_CompareInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_compare = /** @type {((inputs?: Btn_CompareInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_CompareInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_compare(inputs)
	if (locale === "ko") return ko_btn_compare(inputs)
	return ja_btn_compare(inputs)
});